import { formatSearchDistanceKm } from "../utils/searchApi";

export default function SearchDistanceLabel({ value, hasLocation }) {
  if (!hasLocation) return null;

  const formatted = formatSearchDistanceKm(value);
  if (!formatted) return null;

  return <span className="search-result-distance">{formatted}</span>;
}
